import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

export function dateTimeIsFutureValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isoDateTimeString = control.value;

    if (!isoDateTimeString) {
      return null;
    }

    const isoDateTime = DateTime.fromISO(isoDateTimeString);
    if (!isoDateTime.isValid || isoDateTime > DateTime.now()) {
      return { future: { value: isoDateTimeString } };
    }

    return null;
  };
}
